import * as THREE from 'three';

// ─── Renderer / scene ──────────────────────────────────────────────
export const canvas = document.getElementById('c') as HTMLCanvasElement;
export const wrap = document.getElementById('canvas-wrap') as HTMLDivElement;

export const renderer = new THREE.WebGLRenderer({
  canvas,
  antialias: true,
  alpha: true,
  preserveDrawingBuffer: true,
});
renderer.setPixelRatio(window.devicePixelRatio);
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
renderer.outputEncoding = THREE.sRGBEncoding;
renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure = 1.0;

export const scene = new THREE.Scene();
scene.background = new THREE.Color(0x0e0d0b);

export const camera = new THREE.PerspectiveCamera(36, 1, 0.01, 100);

// ─── Environment (procedural studio) ───────────────────────────────
function buildEnvironment(): THREE.Texture {
  const cvs = document.createElement('canvas');
  cvs.width = 1024;
  cvs.height = 512;
  const ctx = cvs.getContext('2d')!;
  // vertical gradient: dark floor -> soft sky
  const g = ctx.createLinearGradient(0, 0, 0, 512);
  g.addColorStop(0.0, '#3a3d44');
  g.addColorStop(0.45, '#23252a');
  g.addColorStop(0.55, '#191a1d');
  g.addColorStop(1.0, '#0c0c0e');
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, 1024, 512);
  // soft "window" highlights for reflections to catch
  function softbox(cx: number, cy: number, w: number, h: number, a: number) {
    const rg = ctx.createRadialGradient(cx, cy, 0, cx, cy, Math.max(w, h));
    rg.addColorStop(0, `rgba(255,250,240,${a})`);
    rg.addColorStop(1, 'rgba(255,250,240,0)');
    ctx.fillStyle = rg;
    ctx.fillRect(cx - w, cy - h, w * 2, h * 2);
  }
  softbox(300, 150, 240, 150, 0.9);
  softbox(760, 180, 180, 120, 0.55);
  softbox(520, 80, 320, 90, 0.4);
  const tex = new THREE.CanvasTexture(cvs);
  tex.mapping = THREE.EquirectangularReflectionMapping;
  const pmrem = new THREE.PMREMGenerator(renderer);
  pmrem.compileEquirectangularShader();
  const env = pmrem.fromEquirectangular(tex).texture;
  tex.dispose();
  pmrem.dispose();
  return env;
}

export const envMap = buildEnvironment();
scene.environment = envMap;

// ─── Lights ────────────────────────────────────────────────────────
export const ambient = new THREE.AmbientLight(0xfff5e0, 0.18);
scene.add(ambient);
export const key = new THREE.DirectionalLight(0xfff8f0, 0.85);
key.position.set(4, 8, 6);
key.castShadow = true;
key.shadow.mapSize.set(2048, 2048);
key.shadow.camera.near = 0.1;
key.shadow.camera.far = 30;
key.shadow.bias = -0.0004;
scene.add(key);
export const fill = new THREE.DirectionalLight(0xc8d8ff, 0.18);
fill.position.set(-5, 2, 3);
scene.add(fill);
export const rim = new THREE.DirectionalLight(0xffe8b0, 0.25);
rim.position.set(-2, -1, -5);
scene.add(rim);
